export const reactQueryConfig = {
	defaultOptions: {
		queries: {
			staleTime: 5 * 60 * 1000, // 5 minutes
			cacheTime: 10 * 60 * 1000, // 10 minutes
			refetchOnWindowFocus: false,
			refetchOnReconnect: false,
			retry: 3, // Retry failed requests up to 3 times
			retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000), // exponential backoff: 1s, 2s, 4s, max 30s
		},
	},
};

export const cubeQueryConfig = {
  token: {
    staleTime: 5 * 60 * 1000,
    cacheTime: 15 * 60 * 1000,
  },
  metadata: {
    staleTime: 15 * 60 * 1000,
    cacheTime: 30 * 60 * 1000,
  },
  data: {
    staleTime: 2 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  },
};